import Iso690 from '../../js/utils/Iso690.js';
import ApaCitation from '../../js/utils/ApaCitation.js';
import VancouverCitation from '../../js/utils/vancouverCitation.js';
import IEEECitation from '../../js/utils/ieeeCitation.js';
import MLACitation from '../../js/utils/mlaCitation.js';
import AbntCitation, { validate as validateAbnt } from '../../js/utils/AbntCitation.js';
import {
    ChicagoAuthorDateCitation,
    ChicagoBibliographyCitation,
    ChicagoNotesCitation,
    validateChicagoAuthorDate,
    validateChicagoBibliography,
    validateChicagoNotes,
} from '../../js/utils/ChicagoCitation.js';

/**
 * Registry of citation formats with their formatter functions and optional validators.
 * A format without a validate function is always available.
 * @type {Object<string, {format: Function, validate?: Function}>}
 */
const formats = {
    Iso690: { format: Iso690 },
    APA: { format: ApaCitation },
    Vancouver: { format: VancouverCitation },
    Chicago: { format: null },
    IEEE: { format: IEEECitation },
    MLA: { format: MLACitation },
    ABNT: { format: AbntCitation, validate: validateAbnt },
    ChicagoNotes: { format: ChicagoNotesCitation, validate: validateChicagoNotes },
    ChicagoBibliography: { format: ChicagoBibliographyCitation, validate: validateChicagoBibliography },
    ChicagoAuthorDate: { format: ChicagoAuthorDateCitation, validate: validateChicagoAuthorDate },
};

const FORMAT_NAMES = ['Iso690', 'APA', 'Vancouver', 'Chicago', 'IEEE', 'MLA', 'ABNT'];
const CHICAGO_SUBFORMAT_NAMES = ['ChicagoNotes', 'ChicagoBibliography', 'ChicagoAuthorDate'];

/**
 * Returns format names whose validator passes (or that have no validator).
 * @param {string[]} formatNames - List of format names to filter
 * @param {Object} issue - Issue object with tags and publication_date
 * @param {string} title - Title from store
 * @returns {string[]} Filtered list of available format names
 */
export function getAvailableFormats(formatNames, issue, title) {
    return formatNames.filter(name => {
        const entry = formats[name];
        return !entry?.validate || entry.validate(issue, title);
    });
}

/**
 * Returns the formatter function for a given format name.
 * @param {string} name - Citation format name
 * @returns {Function|undefined} The formatter function, or undefined if not found
 */
export function getCitationFormatter(name) {
    return formats[name]?.format;
}

export default {
    formats: FORMAT_NAMES,
    chicagoSubformats: CHICAGO_SUBFORMAT_NAMES,
    Iso690,
    APA: ApaCitation,
    Vancouver: VancouverCitation,
    ChicagoNotes: ChicagoNotesCitation,
    ChicagoBibliography: ChicagoBibliographyCitation,
    ChicagoAuthorDate: ChicagoAuthorDateCitation,
    IEEE: IEEECitation,
    MLA: MLACitation,
    ABNT: AbntCitation,
};
